<template>
  <section class="withdrawal-delay" v-if="timer">
    <detail
      v-show="isShowed.timer"
      :prop="i18n.lbl_time_to_tx()"
      :value="timer"
    />

    <div class="withdrawal-delay__controls">
      <md-button
        v-if="isShowed.cancelBtn"
        class="btn md-primary"
        :disabled="pending"
        @click="cancel"
      >
        {{ i18n.lbl_withdrawal_cancel() }}
      </md-button>
      <md-button
        v-if="isShowed.immediateSendBtn"
        class="btn md-primary"
        :disabled="pending"
        @click="send"
      >
        {{ i18n.lbl_send_immediatly() }}
      </md-button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { vuexTypes } from '@vuex/types'
import {i18n} from '@js/i18n'
import DetailsMixin from './details.mixin'
import {withdrawUSDTService} from '@api/withdraw_usdt.service'
import {EventDispatcher} from '@js/events/event_dispatcher'
import {ErrorHandler} from '@js/errors/error_handler'
import {TX_STATES} from '@js/const/tx_states.const'
import { confirmAction } from '@js/modals/confirmation_message'

export default {
  props: ['tx'],
  mixins: [DetailsMixin],
  data: () => ({
    i18n,
    timer: null,
    interval: null,
    pending: false
  }),
  computed: {
    ...mapGetters([
      vuexTypes.approverData
    ]),
    isShowed () {
      const level = this.approverData.approval_level

      return {
        timer: level === 2 || level === 1,
        cancelBtn: level === 2 || level === 1,
        immediateSendBtn: level === 2
      }
    }
  },
  mounted () {
    if (this.tx.delay) {
      this.startCountdown()
    }
  },
  methods: {
    async send () {
      this.pending = true

      try {
        const res = await withdrawUSDTService.applyWithdrawalUSDTRequest({id: this.tx.delay.id})

        if (res) {
          EventDispatcher.dispatchShowErrorEvent(i18n.withdraw_usdt_tx_sent())
        } else {
          EventDispatcher.dispatchShowErrorEvent(i18n.withdraw_usdt_tx_sent_automaticly())
        }

        this.stopCountdown()
        // this.tx.state = TX_STATES.success
        this.$emit('close')
      } catch (error) {
        ErrorHandler.processUnexpected(error)

        if (error && error.response && error.response.status === 400) {
          this.$emit('refetchList')
        }
      }

      this.pending = false
    },
    async cancel () {
      const confirmModalResult = await confirmAction({
        title: i18n.mod_withdrawal_confirm_title(),
        message: i18n.mod_withdrawal_confirm_message(),
        confirmText: i18n.lbl_confirm(),
        cancelText: i18n.lbl_cancel(),
        closeOnEsc: false,
        closeOnBackdrop: false
      })
      if (!confirmModalResult) return

      this.pending = true

      try {
        const res = await withdrawUSDTService.cancelWithdrawalUSDTRequest({id: this.tx.delay.id})

        if (res) {
          EventDispatcher.dispatchShowErrorEvent(i18n.withdraw_usdt_tx_cancelled())
        } else {
          EventDispatcher.dispatchShowErrorEvent(i18n.withdraw_usdt_tx_cancelled_automaticly())
        }

        this.stopCountdown()
        this.tx.state = TX_STATES.rejected
        this.$emit('close')
      } catch (error) {
        ErrorHandler.processUnexpected(error)

        if (error && error.response && error.response.status === 400) {
          this.$emit('refetchList')
        }
      }

      this.pending = false
    },
    startCountdown () {
      this.updateTimer()
      this.interval = setInterval(this.updateTimer, 1000)
    },
    stopCountdown () {
      clearInterval(this.interval)
      this.timer = null
    },
    updateTimer () {
      const currentTime = new Date()
      const differenceInMilliseconds = new Date(this.tx.delay.send_time) - currentTime

      if (differenceInMilliseconds <= 0) {
        this.stopCountdown()
        EventDispatcher.dispatchShowErrorEvent(i18n.withdraw_usdt_tx_sent_automaticly())
        // this.tx.state = TX_STATES.success
        this.$emit('close')
        return
      }

      const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000)
      const minutes = Math.floor(differenceInSeconds / 60)
      const seconds = differenceInSeconds % 60

      this.timer = `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
    }
  },
  beforeDestroy () {
    if (this.interval) {
      this.$emit('close')
      this.stopCountdown()
    }
  }
}
</script>

<style scoped lang="scss">
.withdrawal-delay {
  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    gap: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/WithdrawalDelay.vue